export default "__VITE_ASSET__Td2zZPuQ__"